import { FC, useCallback } from 'react';
import { Calendar } from 'react-date-range';
import { useLocalizedFns } from '../../lib/date-fns';
import { DatePickSingleStyled } from './date-pick-single.styled';
import { IDatePickSingleProps } from './date-pick-single.types';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './theme.css';

export const DatePickSingle: FC<IDatePickSingleProps> = ({
  onChange,
  date,
}) => {
  const handleDateRangeChange = useCallback(
    (newDate: Date) => {
      if (onChange) {
        onChange(newDate);
      }
    },
    [onChange],
  );

  const fnsLocale = useLocalizedFns();

  return (
    <DatePickSingleStyled>
      <Calendar
        date={date}
        onChange={handleDateRangeChange}
        showMonthAndYearPickers={false}
        showDateDisplay={false}
        preventSnapRefocus={true}
        months={1}
        monthDisplayFormat="LLLL y"
        weekdayDisplayFormat="EEEEEE"
        direction="horizontal"
        locale={fnsLocale}
      />
    </DatePickSingleStyled>
  );
};
